import styled from 'styled-components'

export const OrderDetailContainer = styled.div`
  background-color: white;
  margin-bottom: 30px;
  padding: 10px 15px 20px;
`